import type { CurrentPortalDataDTO } from '~/types/TypesFromPortalBackend'

const usePortals = () => {
  const currentPortal = useState<CurrentPortalDataDTO|null>(() => null)

  const loadCurrentPortal = async () => {
    if (currentPortal.value !== null) {
      return
    }

    const { $backend } = useNuxtApp()
    const { data: currentPortalData } = await $backend.portals.getCurrentPortal()

    currentPortal.value = currentPortalData.value?.data ?? null
  }

  const isCurrentPortalHundeLodge = (): boolean => {
    if (currentPortal.value === null) {
      return false
    }

    const portal = currentPortal.value?.portal?.portal ?? ''

    return portal === 'http://www.hunde-lodge.de'
  }

  return {
    loadCurrentPortal,
    currentPortal: readonly(currentPortal) as Readonly<Ref<CurrentPortalDataDTO>>,
    isCurrentPortalHundeLodge
  }
}

// export { usePortals }
export default usePortals
